import LedgersMambuShow from './MambuShow';

export default {
  list: LedgersMambuShow,
};
